import api from './api';

// Busca todas as assuntos (sem paginação)
export function fetchTopics() {
  return api.get('/topics');
}

// Busco assunto por ID
export function getTopicById(id) {
  return api.get(`/topics/${id}`);
}

// Cria uma novo assunto (com suporte a useElastic)
export function createTopic(data, useElastic = false) {
  return api.post('/topics', data, {
    params: { useElastic }
  });
}

// Atualiza um assunto existente
export function updateTopic(data, useElastic = false) {
  return api.put(`/topics/${data.topicId}`, data, {
    params: { useElastic }
  });
}

// Exclui um assunto por ID
export function deleteTopic(id, useElastic = false) {
  return api.delete(`/topics/${id}`, {
    params: { useElastic }
  });
}

// Exclui múltiplos assuntos
export function deleteTopicsBatch(ids, useElastic = false) {
  return api.delete('/topics', {
    params: { useElastic },
    data: ids
  });
}

// Busca paginada com filtro por nome
export function fetchTopicsPaged(pageNumber, pageSize, search = '') {
  return api.get('/topics/paged', {
    params: {
      pageNumber,
      pageSize,
      search
    }
  });
}
